import configureAnalytics from "./events";

export const analyticsFunctions = configureAnalytics({
    segment: window.analytics,
    INNO_ENV: process.env.REACT_APP_INNO_ENV
})